import React from "react";
import { useMediaQuery } from "react-responsive";

import { IoSettingsOutline } from "react-icons/io5";

import { FormContainer } from "../../styled/setting";

import Switch from "../common/form/switch";
import MenuGroupPreview from "./menuGroupPreview";
import InputField from "../common/form/inputField";

const MenuGroupForm = ({ menuGroup, setMenuGroup, toggleModal, selectCompany, domain }) => {
  const isMobile = useMediaQuery({ query: "(max-width:767px)" });

  const changeInput = (e) => {
    const { name, value } = e.target;
    setMenuGroup((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <div className="contents">
      <FormContainer>
        <InputField
          label="메뉴그룹명"
          name="name"
          placeholder="메뉴그룹명을 입력해주세요. 예) 인기상품"
          value={menuGroup.name}
          onChange={changeInput}
          max={10}
        />
        {domain && (
          <Switch
            label="플랫폼"
            keyName="menuPlatform"
            options={{ ALL: "전체", PICKUP: "상생매장" }}
            value={menuGroup.menuPlatform}
            onChange={(value) => setMenuGroup((prev) => ({ ...prev, menuPlatform: value }))}
          />
        )}
        <li className="products">
          <span className="tit">상품</span>
          <div className="cont">
            <button className="setting" onClick={() => toggleModal("link")}>
              상품관리 <IoSettingsOutline />
            </button>
            {menuGroup.products && menuGroup.products.length > 0 && (
              <ul className="menus">
                {menuGroup.products.map((item) => (
                  <li>{item.name}</li>
                ))}
              </ul>
            )}
          </div>
        </li>
      </FormContainer>
      {!isMobile && <MenuGroupPreview menuGroup={menuGroup} />}
    </div>
  );
};

export default MenuGroupForm;
